import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ce73b26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lista" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control has-icons-left has-icons-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Sem Tarefas iniciadas, adicione sua primeira tarefa do dia ! ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Editar Tarefa", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "descricaoDaTarefa",
  class: "label"
}, "Descrição", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_Box = _resolveComponent("Box")!
  const _component_Tarefa = _resolveComponent("Tarefa")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, { onAoAddTarefainList: _ctx.addTarefainList }, null, 8, ["onAoAddTarefainList"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "Pesquisar Tarefas",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtro) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filtro]
          ]),
          _hoisted_4
        ])
      ]),
      (_ctx.ListIsEmpty)
        ? (_openBlock(), _createBlock(_component_Box, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tarefas, (tarefa, index) => {
        return (_openBlock(), _createBlock(_component_Tarefa, {
          key: index,
          tarefa: tarefa,
          onAotarefaClicked: _ctx.selecionarTarefa
        }, null, 8, ["tarefa", "onAotarefaClicked"]))
      }), 128)),
      _createVNode(_component_Modal, {
        mostrar: _ctx.tarefaSelecionada != null
      }, {
        cabecalho: _withCtx(() => [
          _hoisted_6,
          _createElementVNode("button", {
            class: "delete",
            "aria-label": "close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args)))
          })
        ]),
        conteudo: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tarefaSelecionada.description) = $event)),
              id: "descricaoDaTarefa"
            }, null, 512), [
              [_vModelText, _ctx.tarefaSelecionada.description]
            ])
          ])
        ]),
        rodape: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.alterarTarefa && _ctx.alterarTarefa(...args))),
            class: "button is-success"
          }, " Salvar Alterações "),
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.excluirTarefa && _ctx.excluirTarefa(...args))),
            class: "button is-danger"
          }, " Excluir Tarefa ")
        ]),
        _: 1
      }, 8, ["mostrar"])
    ])
  ], 64))
}